import {createSelector} from 'reselect';
import {getSystem} from './store';
import {
    getGeneratedLocale,
    getGeneratedLocaleFormatted,
    getGeneratedLocaleFull
} from '../utils/localeUtils';

const getBrandName = createSelector(
    [getSystem],
    (system) => {
        return system.humanReadableSiteName || '';
    }
);

const getBrandId = createSelector(
    [getSystem],
    (system) => {
        return system.brandId || '';
    }
);

const getBrowserName = createSelector(
    [getSystem],
    (system) => {
        return system.browserName;
    }
);

const getDeviceSize = createSelector(
    [getSystem],
    (system) => {
        return system.deviceSize;
    }
);

const getWidth = createSelector(
    [getSystem],
    (system) => system.width
);

const getHeight = createSelector(
    [getSystem],
    (system) => system.height
);

const getIsDesktop = createSelector(
    [getSystem],
    (system) => {
        return system.isDesktop;
    }
);

const getIsMobile = createSelector(
    [getSystem],
    (system) => {
        return system.isMobile;
    }
);

const getCurrency = createSelector(
    [getSystem],
    (system) => system.currency
);

const getLocale = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocale(system.locale);
    }
);

const getLocaleFull = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFull(system.locale);
    }
);

const getLocaleJS = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFormatted(system.locale);
    }
);

const getReviewPageSize = createSelector(
    [getSystem],
    (system) => {
        return system.reviewPageSize;
    }
);

const getSiteName = createSelector(
    [getSystem],
    (system) => {
        return system.siteName;
    }
);

const getSystemClientSideRendered = createSelector(
    [getSystem],
    (system) => {
        return system.clientSideRendered;
    }
);

const getBathroomStrategy = createSelector(
    [getSystem],
    (system) => {
        return system.bathroomStrategy;
    }
);

const getHostName = createSelector(
    [getSystem],
    (system) => {
        return system.hostName;
    }
);

const getIsInternalUser = createSelector(
    [getSystem],
    (system) => {
        return system.isInternalUser;
    }
);

const getBaseUrlPath = createSelector(
    [getSystem],
    (system) => {
        return system.baseUrlPath;
    }
);

const getLanguageNativeName = createSelector(
    [getSystem],
    (system) => {
        return system.languageNativeName;
    }
);

const getLanguageName = createSelector(
    [getSystem],
    (system) => {
        return system.languageName;
    }
);

const getEnvironment = createSelector(
    [getSystem],
    (system) => {
        return system.environment;
    }
);

const getHavId = createSelector(
    [getSystem],
    (system) => {
        return system.havId || '';
    }
);

const getGaiaId = createSelector(
    [getSystem],
    (system) => {
        return system.gaiaId || '';
    }
);

export {
    getBrandName,
    getBrandId,
    getBrowserName,
    getDeviceSize,
    getWidth,
    getHeight,
    getHostName,
    getIsDesktop,
    getIsMobile,
    getCurrency,
    getLocale,
    getLocaleFull,
    getLocaleJS,
    getReviewPageSize,
    getSiteName,
    getSystemClientSideRendered,
    getBathroomStrategy,
    getBaseUrlPath,
    getLanguageNativeName,
    getLanguageName,
    getEnvironment,
    getIsInternalUser,
    getHavId,
    getGaiaId
};
